import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './VerifyEmail.css';
import api from '../services/api';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get('token');
      
      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link. No token provided.');
        return;
      }

      try {
        const response = await api.get(`/auth/verify-email/${token}`);
        
        if (response.data.success) {
          setStatus('success');
          setMessage(response.data.message);
          setUserName(response.data.user?.name || '');
          
          // Redirect to login page after 3 seconds
          setTimeout(() => {
            navigate('/login');
          }, 3000);
        } else {
          setStatus('error');
          setMessage(response.data.message || 'Verification failed');
        }
      } catch (error) {
        setStatus('error');
        setMessage(
          error.response?.data?.message || 
          'An error occurred during verification. Please try again.'
        );
      }
    };

    verifyEmail();
  }, [searchParams, navigate]);

  return (
    <div className="verify-email-page">
      <div className="verify-container">
        <div className="verify-content">
          {status === 'verifying' && (
            <>
              <div className="spinner"></div>
              <h1>Verifying Your Email</h1>
              <p>Please wait while we verify your email address...</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="success-checkmark">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#f59e0b" strokeWidth="2"/>
                  <path d="M8 12l2 2 4-4" stroke="#f59e0b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <h1>Email Verified Successfully!</h1>
              {userName && <p className="welcome-text">Welcome, {userName}!</p>}
              <p>{message}</p>
              <div className="redirect-info">
                <p>Redirecting you to the login page in a few seconds...</p>
                <button 
                  onClick={() => navigate('/login')}
                  className="btn-login"
                >
                  Go to Login Now
                </button>
              </div>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="error-icon">
                <svg width="80" height="80" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="2"/>
                  <line x1="12" y1="8" x2="12" y2="12" stroke="#ef4444" strokeWidth="2" strokeLinecap="round"/>
                  <circle cx="12" cy="16" r="0.5" fill="#ef4444" stroke="#ef4444" strokeWidth="2"/>
                </svg>
              </div>
              <h1>Verification Failed</h1>
              <p>{message}</p>
              <div className="action-buttons">
                <button 
                  onClick={() => navigate('/')}
                  className="btn-home"
                >
                  Go to Home
                </button>
                <button 
                  onClick={() => navigate('/login')}
                  className="btn-login-alt"
                >
                  Try Login
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
